import {NgModule} from '@angular/core';
import {ToolbarComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {IconComponentModule} from '../icon/item.module';
import {ClickOutsideModule} from 'ng-click-outside';
import {BrowserModule} from '@angular/platform-browser';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    IconComponentModule,
    BrowserModule,
    ClickOutsideModule,
  ],
  exports: [
    ToolbarComponent
  ],
  declarations: [ToolbarComponent],
  providers: [],
})
export class ToolbarComponentModule {
}
